import axios from "axios"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { useModal } from "../contexts/Modal.context"

export const baseUrl = process.env.REACT_APP_BASE_URL

export function useFetch({ url, key, enabled = true, keepPreviousData = false, strict, placeholderData }) {
    placeholderData = { "data": [], "status": "", "message": "", "meta": {} }

    const handleFetch = async () => {
        const address = baseUrl + (url ?? key)
        // console.log("fetching" + address)
        if (key || url) {
            const response = await axios.get(address)
            return response.data
        }
    }

    const { data = placeholderData, status, isLoading, isSuccess, isError, error, refetch, isFetching } = useQuery({
        enabled,
        queryKey: key ?? url,
        queryFn: handleFetch,
        keepPreviousData,
        onError: (err) => {
            console.log(err)
            if (strict) {
                //do something
            }
        }
    })

    return { status, isLoading, isSuccess, isError, data, error, refetch, isFetching }
}

export function useMutate({ url, refetchKeys, successMessage }) {
    const queryClient = useQueryClient()
    const { notify } = useModal()

    const { data, isLoading, isSuccess, isError, mutate, reset } = useMutation(data =>
        axios.post(baseUrl + url, data),
        {
            onSuccess: (data) => {
                if (refetchKeys) refetchKeys.forEach(k => queryClient.refetchQueries(k))
                notify(successMessage ?? "Request processed successfully")
                // console.log(data.data)
                reset()
            },
            onError: (error) => {
                notify("There was an error", "error")
                console.log("error!--->", error.message)
            }
        }
    )

    return { data, isLoading, isSuccess, isError, mutate, reset }
}

